/**
 * @generated SignedSource<<a19c0615ace1195d987c042f3ca33a14>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type LinkRelationshipTypeCell$data = {
  readonly id: string;
  readonly lazyIsEditableInIssueView?: boolean | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"ui_IssueFieldLinkRelationshipInlineEditFull_LinkRelationshipInlineEditView">;
  readonly " $fragmentType": "LinkRelationshipTypeCell";
};
export type LinkRelationshipTypeCell$key = {
  readonly " $data"?: LinkRelationshipTypeCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"LinkRelationshipTypeCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "LinkRelationshipTypeCell",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "condition": "isInlineEditingEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "lazyIsEditableInIssueView"
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "ui_IssueFieldLinkRelationshipInlineEditFull_LinkRelationshipInlineEditView"
    }
  ],
  "type": "JiraIssueLinkRelationshipTypeField"
};

(node as any).hash = "46166348803039eacdfc135dad1c910a";

export default node;
